import list from './list'
import icon from '@mui/icons-material/Sms'

const adminConfig = { list, icon };

export default adminConfig;
